module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/badanie-techniczne-white@500x-aabeaa6c.png";